// extracted by mini-css-extract-plugin
module.exports = {"CategoryBottomPage":"styles_CategoryBottomPage__J8pWt","heroCategorySimpleDescription":"styles_heroCategorySimpleDescription__tHoBY","heroMainText":"styles_heroMainText__8MD27"};